module.exports = __webpack_public_path__ + "static/media/img-logical-system.e53fa15a.png";